import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Start = _resolveComponent("Start")!
  const _component_Personal = _resolveComponent("Personal")!
  const _component_Experience = _resolveComponent("Experience")!
  const _component_Education = _resolveComponent("Education")!
  const _component_Science = _resolveComponent("Science")!
  const _component_Skills = _resolveComponent("Skills")!
  const _component_Languages = _resolveComponent("Languages")!
  const _component_Projects = _resolveComponent("Projects")!
  const _component_Achievements = _resolveComponent("Achievements")!
  const _component_Interests = _resolveComponent("Interests")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Start),
    _createElementVNode("main", null, [
      _createVNode(_component_Personal),
      _createVNode(_component_Experience),
      _createVNode(_component_Education),
      _createVNode(_component_Science),
      _createVNode(_component_Skills),
      _createVNode(_component_Languages),
      _createVNode(_component_Projects),
      _createVNode(_component_Achievements),
      _createVNode(_component_Interests)
    ])
  ]))
}